var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ref, toValue, computed } from "vue";
import { watchDebounced } from "@vueuse/core";
import { useComponentStoreV2 } from "..";
import { useDefaultComponentTypes } from "../../component-type/composables/useDefaultComponentTypes";
const getAllSubTypeNames = (type, defaultComponentTypes) => {
    const childComponentTypeNames = [];
    const childTypes = defaultComponentTypes.filter((componentType) => componentType.parent === type);
    childTypes.forEach((childType) => {
        childComponentTypeNames.push(childType.type);
        childComponentTypeNames.push(...getAllSubTypeNames(childType.type, defaultComponentTypes));
    });
    return childComponentTypeNames;
};
const isComponentType = (component, typeName, defaultComponentTypes) => {
    if (component.type === null) {
        return false;
    }
    if (component.type === typeName) {
        return true;
    }
    const subTypes = getAllSubTypeNames(typeName, defaultComponentTypes);
    return subTypes.includes(component.type);
};
const filterComponentCandidatesBySocketFilter = (candidates, filter, defaultComponentTypes) => {
    if (!(filter === null || filter === void 0 ? void 0 : filter.component_type)) {
        return candidates;
    }
    return candidates.filter((candidate) => isComponentType(candidate, filter.component_type, defaultComponentTypes));
};
export const useComponentDuplicationCandidates = (targetComponentId, targetSocket, showAll) => {
    const componentStore = useComponentStoreV2();
    const isLoading = ref(false);
    const componentDuplicationCandidates = ref([]);
    const { defaultComponentTypes } = useDefaultComponentTypes();
    const availableClientIds = computed(() => {
        const clientIds = new Set();
        componentDuplicationCandidates.value.forEach((component) => {
            if (component.source_client_id) {
                clientIds.add(component.source_client_id);
            }
        });
        return Array.from(clientIds).sort();
    });
    const setDuplicationCandidates = (targetComponentId, targetSocket, showAll) => __awaiter(void 0, void 0, void 0, function* () {
        isLoading.value = true;
        const targetSocketName = (targetSocket === null || targetSocket === void 0 ? void 0 : targetSocket.name) || null;
        const targetSocketFilter = (targetSocket === null || targetSocket === void 0 ? void 0 : targetSocket.filter) || null;
        try {
            const candidates = yield componentStore.fetchDuplicatableComponents(Object.assign(Object.assign(Object.assign({ target_component_id: targetComponentId }, (targetSocketName && {
                target_socket_name: targetSocketName,
            })), (showAll && {
                show_all: showAll,
            })), (!showAll && {
                exclude_having_all_tags: "internal:no-clone",
            })));
            componentDuplicationCandidates.value =
                filterComponentCandidatesBySocketFilter(candidates, targetSocketFilter, toValue(defaultComponentTypes));
        }
        finally {
            isLoading.value = false;
        }
    });
    watchDebounced([
        () => toValue(targetComponentId),
        () => toValue(targetSocket),
        () => toValue(showAll),
    ], ([targetComponentIdValue, targetSocketValue, showAllValue]) => {
        if (targetComponentIdValue) {
            setDuplicationCandidates(targetComponentIdValue, targetSocketValue, showAllValue);
        }
    }, {
        debounce: 300,
        immediate: true,
    });
    return {
        isLoading,
        componentDuplicationCandidates,
        availableClientIds,
    };
};
